/* Quiz Bundle Shell — behavior for sections/quiz-bundle-shell.liquid.
 *
 * Design: the cart IS the selection. A checkmark adds that accessory to the
 * cart (ajax); un-checking removes it. The sticky tracker re-reads /cart.js
 * after every change, so the savings shown are Shopify's own computed BXGY
 * discount (line.total_discount), never re-implemented math. Before the bike
 * is in the cart the discount isn't active yet, so we show a clearly-labeled
 * estimate (10% of every pick — the offer is uncapped) and prompt Step 1.
 *
 * The featured bike card is a full on-page picker: every Brompton is a clean
 * two-option product (Color x Handlebar/Size), so we render selects from the
 * product .js JSON, swap the variant photo, and add the resolved variant
 * straight to the cart. Clicking a bike in the strip swaps it into the
 * featured slot instead of leaving the page.
 */
(function () {
  'use strict';

  var root = document.getElementById('quiz-bundle');
  if (!root) return;

  var data;
  try {
    data = JSON.parse(document.getElementById('qb-data').textContent);
    var pct = parseInt(data.discountPercent, 10) || 10;
  } catch (e) { return; }

  var productIds = data.productIds || [];
  var bikeIds = (data.bikeIds || []).filter(function (id) {
    return productIds.indexOf(id) === -1; // never double-count
  });

  /* variant id -> product handle for out-of-stock variants on bikes tagged
     'lets-talk' (tracked, qty <= 0 -- the same rule as the PDP's special-order
     guard in buy-buttons.liquid). These aren't sold from the quiz: the button
     sends the shopper to the product page, where the inquiry form starts the
     conversation before any money changes hands. */
  var letsTalk = data.letsTalk || {};

  var params = new URLSearchParams(window.location.search);

  /* ---------- helpers ---------- */
  function money(cents) {
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    var whole = amount.split('.')[0];
    var frac = amount.split('.')[1];
    whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + whole + (frac ? '.' + frac : '');
  }
  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function imgUrl(src, w) {
    if (!src) return null;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  /* ---------- personal bar: code reveal + live expiry ---------- */
  function getCode() {
    var p = params.get('code');
    if (p) return p.toUpperCase();
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    if (m) {
      try { return decodeURIComponent(m[1]).toUpperCase(); } catch (e) { return null; }
    }
    return null;
  }
  var code = getCode();
  if (code && !/^[A-Z0-9-]{4,40}$/.test(code)) code = null;

  var codeEl = document.getElementById('qb-code');
  var badgeEl = document.getElementById('qb-badge');
  var expEl = document.getElementById('qb-expiry');
  var reduceMotion = false;
  try { reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  /* Play the tumbler once per browser per code; replays read as glitch. */
  function revealSeen() {
    try { return localStorage.getItem('qb-revealed') === code; } catch (e) { return true; }
  }
  function markRevealed() {
    try { localStorage.setItem('qb-revealed', code); } catch (e) {}
  }

  var revealReadyAt = 0;
  function showCodeInstant() {
    codeEl.textContent = code;
    codeEl.hidden = false;
    if (badgeEl) badgeEl.hidden = false;
  }

  var SPIN_CHARS = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  function revealCode() {
    var spans = [];
    var locked = [];
    codeEl.textContent = '';
    for (var i = 0; i < code.length; i++) {
      var s = document.createElement('span');
      if (code.charAt(i) === '-') {
        s.textContent = '-';
        locked.push(true);
      } else {
        s.className = 'is-spin';
        s.textContent = SPIN_CHARS.charAt(Math.floor(Math.random() * SPIN_CHARS.length));
        locked.push(false);
      }
      spans.push(s);
      codeEl.appendChild(s);
    }
    codeEl.hidden = false;
    var spinTimer = setInterval(function () {
      for (var i = 0; i < spans.length; i++) {
        if (!locked[i]) spans[i].textContent = SPIN_CHARS.charAt(Math.floor(Math.random() * SPIN_CHARS.length));
      }
    }, 55);
    var delay = 300;
    for (var i = 0; i < code.length; i++) {
      if (code.charAt(i) === '-') continue;
      (function (idx, d) {
        setTimeout(function () {
          locked[idx] = true;
          spans[idx].textContent = code.charAt(idx);
          spans[idx].className = 'is-locked';
        }, d);
      })(i, delay);
      delay += 72;
    }
    setTimeout(function () { clearInterval(spinTimer); }, delay + 60);
    setTimeout(function () {
      if (badgeEl) {
        badgeEl.hidden = false;
        badgeEl.classList.add('is-stamp');
      }
      markRevealed();
    }, delay + 150);
    revealReadyAt = Date.now() + delay + 420;
  }

  if (code && codeEl) {
    if (reduceMotion || revealSeen()) showCodeInstant();
    else revealCode();
  }

  /* Expiry: ask clearsignal for the live timestamp — the /discount
     redirect drops our query params, so the page knows the code (from
     Shopify's discount_code cookie) but not when it dies. Falls back
     to the ?exp= param when the lookup fails. Inside ~4 days we tick
     a live countdown; further out (older 30-day codes) a static date
     reads better than a 700-hour clock. */
  var expiryTimer = null;
  function showExpiry(iso) {
    if (!expEl) return;
    var end = new Date(iso).getTime();
    if (isNaN(end)) return;
    var wait = Math.max(0, revealReadyAt - Date.now());
    setTimeout(function () {
      var left = end - Date.now();
      if (left <= 0) return; /* expired: the bar stays quiet rather than nagging */
      if (left > 96 * 3600 * 1000) {
        expEl.textContent = 'Expires ' + new Date(end).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
        expEl.hidden = false;
        return;
      }
      var b = document.createElement('b');
      expEl.textContent = 'expires in ';
      expEl.appendChild(b);
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function tick() {
        var ms = end - Date.now();
        if (ms <= 0) {
          clearInterval(expiryTimer);
          expEl.textContent = 'Your code just expired';
          return;
        }
        b.textContent = pad(Math.floor(ms / 3600000)) + ':' +
          pad(Math.floor(ms % 3600000 / 60000)) + ':' +
          pad(Math.floor(ms % 60000 / 1000));
      }
      tick();
      expEl.hidden = false;
      expiryTimer = setInterval(tick, 1000);
    }, wait);
  }
  function expiryFallback() {
    var exp = params.get('exp');
    if (exp && /^\d{4}-\d{2}-\d{2}$/.test(exp)) {
      var d = new Date(exp + 'T12:00:00');
      if (!isNaN(d)) showExpiry(d.toISOString());
    }
  }
  if (code && expEl && window.fetch) {
    fetch('https://clearsignal-two.vercel.app/api/public/bundle-code?code=' + encodeURIComponent(code))
      .then(function (r) { if (!r.ok) throw new Error('lookup ' + r.status); return r.json(); })
      .then(function (j) {
        if (j && j.expiresAt) showExpiry(j.expiresAt);
        else expiryFallback();
      })
      .catch(expiryFallback);
  } else {
    expiryFallback();
  }

  /* ---------- cart state (declared early; featured picker reads it) ---------- */
  var cards = Array.prototype.slice.call(root.querySelectorAll('.qb-card'));
  var trackerEl = document.getElementById('qb-tracker');
  var msgEl = document.getElementById('qb-tracker-msg');
  var ctaEl = document.getElementById('qb-tracker-cta');
  var checkoutBtn = document.getElementById('qb-checkout-btn');
  var checkoutNote = document.getElementById('qb-checkout-note');
  var countEl = document.getElementById('qb-count');
  var cart = null;

  function cartLineFor(productId) {
    if (!cart) return null;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].product_id === productId) return cart.items[i];
    }
    return null;
  }
  function cartLineForVariant(variantId) {
    if (!cart) return null;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === variantId) return cart.items[i];
    }
    return null;
  }
  function bikeInCart() {
    if (!cart) return false;
    return cart.items.some(function (it) { return bikeIds.indexOf(it.product_id) !== -1; });
  }

  /* ---------- featured bike picker ---------- */
  var featuredEl = document.getElementById('qb-featured-bike');
  var featuredProduct = null;
  var featuredIsMatch = false;
  var hiddenStripCard = null;

  function resolveVariant() {
    if (!featuredProduct) return null;
    var sels = featuredEl.querySelectorAll('select[data-opt]');
    var chosen = Array.prototype.map.call(sels, function (s) { return s.value; });
    for (var i = 0; i < featuredProduct.variants.length; i++) {
      var v = featuredProduct.variants[i];
      var ok = true;
      for (var j = 0; j < chosen.length; j++) {
        if (v.options[j] !== chosen[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function updateFeatured() {
    if (!featuredProduct) return;
    var v = resolveVariant();
    var img = featuredEl.querySelector('#qb-featured-img');
    var price = featuredEl.querySelector('#qb-featured-price');
    var btn = featuredEl.querySelector('#qb-featured-add');
    var status = featuredEl.querySelector('#qb-featured-status');

    var src = (v && v.featured_image && v.featured_image.src) || featuredProduct.featured_image;
    if (img && src && img.getAttribute('data-src') !== src) {
      img.src = imgUrl(src, 900);
      img.setAttribute('data-src', src);
    }
    if (price) {
      price.textContent = v ? money(v.price) : 'From ' + money(featuredProduct.price);
    }
    if (!btn) return;

    var line = v ? cartLineForVariant(v.id) : null;
    var lt = v ? letsTalk[String(v.id)] : null;
    btn.classList.toggle('is-in', !!line);
    btn.setAttribute('aria-pressed', String(!!line));
    delete btn.dataset.qbLetsTalk;
    status.hidden = true;
    if (!v) {
      btn.disabled = true;
      btn.textContent = 'Not offered in this combination';
    } else if (line) {
      btn.disabled = false;
      btn.innerHTML = 'In your bundle &#10003; &mdash; tap to remove';
    } else if (lt) {
      btn.disabled = false;
      btn.textContent = 'Let\u2019s talk \u2014 we can order this in';
      btn.dataset.qbLetsTalk = lt;
      status.innerHTML = 'Tell us when you need this bike and we\u2019ll check with our Brompton warehouse \u2014 an answer and a firm timeline within one business day, and nothing to pay until it\u2019s confirmed. Every bike gets our free <a href="/pages/brompton-pro-build">Expert Pro-Build</a> \u2014 built, dialed in, and test-ridden by our Brompton mechanics.';
      status.hidden = false;
    } else if (!v.available) {
      var anyAvailable = featuredProduct.variants.some(function (x) { return x.available; });
      btn.disabled = true;
      btn.textContent = anyAvailable ? 'Out of stock in this setup' : 'Sold out right now';
      status.textContent = anyAvailable
        ? 'Try another color or setup \u2014 or reply to your offer email and we\u2019ll extend your code when this one is back.'
        : 'This model is sold out. Pick another below \u2014 or reply to your offer email and we\u2019ll extend your code when it\u2019s back.';
      status.hidden = false;
    } else {
      btn.disabled = false;
      btn.textContent = 'Add to my bundle';
    }
  }

  function loadBike(handle, isMatch, scrollTo) {
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return;
        featuredProduct = p;
        featuredIsMatch = isMatch;

        var def = null;
        var inCartLine = cartLineFor(p.id);
        if (inCartLine) {
          for (var i = 0; i < p.variants.length; i++) {
            if (p.variants[i].id === inCartLine.variant_id) { def = p.variants[i]; break; }
          }
        }
        if (!def) {
          for (var k = 0; k < p.variants.length; k++) {
            if (p.variants[k].available) { def = p.variants[k]; break; }
          }
        }
        def = def || p.variants[0];

        var selects = p.options.map(function (o, oi) {
          var opts = o.values.map(function (val) {
            var sel = def && def.options[oi] === val ? ' selected' : '';
            return '<option value="' + esc(val) + '"' + sel + '>' + esc(val) + '</option>';
          }).join('');
          return '<label class="qb-select"><span>' + esc(o.name) + '</span>' +
            '<select data-opt="' + oi + '">' + opts + '</select></label>';
        }).join('');

        featuredEl.innerHTML =
          '<div class="qb-featured__img">' +
            (isMatch ? '<span class="qb-featured__badge">Your match</span>' : '') +
            '<img id="qb-featured-img" alt="' + esc(p.title) + '">' +
          '</div>' +
          '<div class="qb-featured__info">' +
            '<h3>' + esc(p.title.replace(' Folding Bike', '')) + '</h3>' +
            '<div class="qb-featured__price" id="qb-featured-price"></div>' +
            (isMatch ? '<p class="qb-featured__note">This is the model your quiz answers pointed to.</p>' : '') +
            '<div class="qb-featured__selects">' + selects + '</div>' +
            '<button type="button" class="qb-btn" id="qb-featured-add">Add to my bundle</button>' +
            '<p class="qb-featured__note" id="qb-featured-status" hidden></p>' +
            '<a class="qb-featured__link" href="/products/' + esc(p.handle) + '">Full details &amp; specs &rarr;</a>' +
          '</div>';
        featuredEl.hidden = false;

        if (hiddenStripCard) hiddenStripCard.style.display = '';
        hiddenStripCard = root.querySelector('.qb-bike[data-bike-handle="' + p.handle + '"]');
        if (hiddenStripCard) hiddenStripCard.style.display = 'none';

        updateFeatured();
        if (scrollTo) {
          featuredEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      })
      .catch(function () {});
  }

  featuredEl.addEventListener('change', function (e) {
    if (e.target.matches('select[data-opt]')) updateFeatured();
  });

  featuredEl.addEventListener('click', function (e) {
    var btn = e.target.closest('#qb-featured-add');
    if (!btn || btn.disabled) return;
    var v = resolveVariant();
    if (!v) return;
    if (btn.dataset.qbLetsTalk) {
      /* special order: the conversation happens on the PDP's inquiry form */
      window.location.href = '/products/' + btn.dataset.qbLetsTalk + '?variant=' + v.id;
      return;
    }
    var line = cartLineForVariant(v.id);
    btn.disabled = true;

    var req;
    if (line) {
      req = fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: 0, sections: 'cart-icon-bubble' })
      });
    } else {
      var item = { id: v.id, quantity: 1 };
      req = fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [item],
          sections: 'cart-icon-bubble'
        })
      });
    }
    req
      .then(function (r) { return r.json(); })
      .then(function (resp) { refreshCartIcon(resp.sections); })
      .catch(function () {})
      .then(function () { return fetchCart(); })
      .then(function () { btn.disabled = false; updateFeatured(); });
  });

  var rec = params.get('rec');
  if (rec && /^[a-z0-9-]+$/.test(rec)) {
    loadBike(rec, true, false);
  }

  /* strip bikes swap into the featured slot instead of leaving the page */
  var bikesWrap = root.querySelector('.qb-bikes');
  if (bikesWrap) {
    bikesWrap.addEventListener('click', function (e) {
      var a = e.target.closest('.qb-bike');
      if (!a || a.classList.contains('qb-bike--all')) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var h = a.getAttribute('data-bike-handle');
      if (!h) return;
      e.preventDefault();
      loadBike(h, h === rec, true);
    });
  }

  /* ---------- remember which bundle page this shopper belongs to ---------- */
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: { quiz_bundle_collection: data.collectionHandle } })
  }).catch(function () {});

  /* ---------- cart fetch + render ---------- */
  function fetchCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; render(); return c; })
      .catch(function () {});
  }

  function render() {
    var picked = [];
    cards.forEach(function (card) {
      var pid = parseInt(card.dataset.productId, 10);
      var line = cartLineFor(pid);
      var on = !!line;
      card.classList.toggle('is-picked', on);
      var btn = card.querySelector('[data-role="pick"]');
      btn.setAttribute('aria-pressed', String(on));
      btn.querySelector('.qb-pick__label').textContent = on ? 'In your bundle' : 'Add to my bundle';
      if (on) picked.push({ card: card, line: line, price: parseInt(card.dataset.price, 10) });
    });

    var hasBike = bikeInCart();
    var n = picked.length;

    // real savings from Shopify's math; estimate covers any cart.js lag
    var realSave = picked.reduce(function (s, p) { return s + (p.line.total_discount || 0); }, 0);
    var estSave = Math.round(picked.reduce(function (s, p) { return s + p.price; }, 0) * (pct / 100));
    var save = realSave > 0 ? realSave : estSave;

    // per-card prices
    cards.forEach(function (card) {
      card.querySelector('[data-role="prices"]').innerHTML = cardPriceHtml(card);
    });

    if (countEl) {
      countEl.textContent = String(n);
      countEl.classList.toggle('is-on', n > 0);
    }
    trackerEl.classList.remove('is-done');

    var plural = n === 1 ? 'accessory' : 'accessories';
    if (n === 0 && !hasBike) {
      msgEl.innerHTML = '<strong>Pick your accessories</strong> &mdash; ' + pct + '% off every one with your Brompton.' +
        '<small>Your discount is already applied. No code to enter.</small>';
      ctaEl.textContent = 'Start picking';
      ctaEl.dataset.action = 'grid';
    } else if (n === 0) {
      msgEl.innerHTML = '<strong>Your Brompton&rsquo;s in &#10003;</strong> Every accessory you add now is ' + pct + '% off.' +
        '<small>Your discount is already applied. No code to enter.</small>';
      ctaEl.textContent = 'Pick accessories';
      ctaEl.dataset.action = 'grid';
    } else if (!hasBike) {
      msgEl.innerHTML = '<strong>' + n + ' ' + plural + ' picked</strong> &mdash; <span class="qb-save">' + money(save) + '</span> off, already applied.' +
        '<small>Now the fun part: choose the Brompton they go with.</small>';
      ctaEl.textContent = 'Choose your Brompton ↑';
      ctaEl.dataset.action = 'bikes';
    } else {
      trackerEl.classList.add('is-done');
      var label = realSave > 0
        ? 'You&rsquo;re saving <span class="qb-save">' + money(save) + '</span> &mdash; ' + pct + '% off every accessory.'
        : 'Your ' + pct + '% comes off at checkout.';
      msgEl.innerHTML = '<strong>' + n + ' ' + plural + ' with your bike &#10003;</strong> ' + label +
        '<small>' + (code ? 'Applied by code ' + code + '. ' : '') + 'Keep adding &mdash; each one is ' + pct + '% off.</small>';
      ctaEl.textContent = realSave > 0 ? 'Check out — saving ' + money(save) : 'Review cart & check out';
      ctaEl.dataset.action = 'checkout';
    }

    if (checkoutBtn) {
      var cartEmpty = n === 0 && !hasBike;
      checkoutBtn.classList.toggle('is-empty', cartEmpty);
      checkoutBtn.setAttribute('aria-disabled', cartEmpty ? 'true' : 'false');
      if (cartEmpty) {
        checkoutBtn.textContent = 'Review cart & check out';
        checkoutNote.innerHTML = 'Nothing in your cart yet &mdash; check off a few accessories above and this lights up.';
      } else if (n === 0) {
        checkoutBtn.textContent = 'Review cart & check out';
        checkoutNote.innerHTML = 'Your Brompton&rsquo;s in the cart &mdash; each accessory you add above is ' + pct + '% off.';
      } else if (!hasBike) {
        checkoutBtn.textContent = 'Review cart & check out';
        checkoutNote.innerHTML = n + ' ' + plural + ' in your cart &mdash; <span class="qb-save">' + money(save) + '</span> off, already applied.';
      } else {
        checkoutBtn.textContent = realSave > 0 ? 'Check out — saving ' + money(save) : 'Review cart & check out';
        checkoutNote.innerHTML = n + ' ' + plural + ' + your Brompton &#10003;' + (code ? ' &mdash; code ' + code + ' applied.' : '');
      }
    }

    updateFeatured();
    syncQv();
  }

  /* ---------- Dawn cart icon refresh ---------- */
  function refreshCartIcon(sections) {
    if (!sections || !sections['cart-icon-bubble']) return;
    var el = document.getElementById('cart-icon-bubble');
    if (el) el.innerHTML = sections['cart-icon-bubble'];
  }

  /* ---------- pick / unpick ---------- */
  root.querySelector('.qb-grid').addEventListener('click', function (e) {
    var btn = e.target.closest('[data-role="pick"]');
    if (!btn) return;
    var card = btn.closest('.qb-card');
    var pid = parseInt(card.dataset.productId, 10);
    var line = cartLineFor(pid);
    btn.disabled = true;

    var req;
    if (line) {
      req = fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: 0, sections: 'cart-icon-bubble' })
      });
    } else {
      req = fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(card.dataset.variantId, 10), quantity: 1 }],
          sections: 'cart-icon-bubble'
        })
      });
    }

    req
      .then(function (r) { return r.json(); })
      .then(function (resp) { refreshCartIcon(resp.sections); })
      .catch(function () {})
      .then(function () { return fetchCart(); })
      .then(function () { btn.disabled = false; });
  });


  /* ---------- quick view: tiles open a popup instead of the PDP ---------- */
  var qvEl = document.getElementById('qb-qv');
  var qvCard = null;
  var qvCache = {};
  var qvLastFocus = null;

  function cardPriceHtml(card) {
    var price = parseInt(card.dataset.price, 10);
    var line = cartLineFor(parseInt(card.dataset.productId, 10));
    if (line && line.total_discount > 0) {
      return '<span class="qb-price qb-price--was">' + money(line.original_line_price) + '</span>' +
        '<span class="qb-price qb-price--now">' + money(line.final_line_price) + '</span>';
    }
    return '<span class="qb-price">' + money(price) + '</span>';
  }

  function syncQv() {
    if (!qvEl || !qvCard) return;
    var pickBtn = document.getElementById('qb-qv-pick');
    var on = !!cartLineFor(parseInt(qvCard.dataset.productId, 10));
    pickBtn.setAttribute('aria-pressed', String(on));
    pickBtn.querySelector('.qb-pick__label').textContent = on ? 'In your bundle' : 'Add to my bundle';
    document.getElementById('qb-qv-prices').innerHTML = cardPriceHtml(qvCard);
  }

  function renderQvProduct(p) {
    var main = document.getElementById('qb-qv-img');
    var thumbs = document.getElementById('qb-qv-thumbs');
    document.getElementById('qb-qv-title').textContent = p.title;
    var imgs = (p.images || []).slice(0, 6);
    if (!imgs.length && p.featured_image) imgs = [p.featured_image];
    if (imgs.length) { main.src = imgUrl(imgs[0], 720); main.alt = p.title; }
    thumbs.innerHTML = '';
    if (imgs.length > 1) {
      imgs.forEach(function (src, i) {
        var b = document.createElement('button');
        b.type = 'button';
        if (i === 0) b.className = 'is-on';
        b.innerHTML = '<img src="' + esc(imgUrl(src, 120)) + '" alt="" loading="lazy">';
        b.addEventListener('click', function () {
          main.src = imgUrl(src, 720);
          Array.prototype.forEach.call(thumbs.children, function (c) { c.className = ''; });
          b.className = 'is-on';
        });
        thumbs.appendChild(b);
      });
    }
    document.getElementById('qb-qv-desc').innerHTML = p.description || '';
    syncQv();
  }

  function openQv(card) {
    if (!qvEl || !card) return;
    qvCard = card;
    qvLastFocus = document.activeElement;
    var titleEl = card.querySelector('h3');
    var title = titleEl ? titleEl.textContent.trim() : '';
    document.getElementById('qb-qv-title').textContent = title;
    var tileImg = card.querySelector('.qb-card__img img');
    var main = document.getElementById('qb-qv-img');
    main.src = tileImg ? tileImg.src : '';
    main.alt = title;
    document.getElementById('qb-qv-thumbs').innerHTML = '';
    document.getElementById('qb-qv-desc').innerHTML = '';
    syncQv();
    qvEl.hidden = false;
    document.documentElement.classList.add('qb-qv-open');
    qvEl.querySelector('.qb-qv__close').focus();

    var handle = card.dataset.handle;
    if (!handle) return;
    if (qvCache[handle]) { renderQvProduct(qvCache[handle]); return; }
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return;
        qvCache[handle] = p;
        if (qvCard === card && !qvEl.hidden) renderQvProduct(p);
      })
      .catch(function () {});
  }

  function closeQv() {
    if (!qvEl || qvEl.hidden) return;
    qvEl.hidden = true;
    qvCard = null;
    document.documentElement.classList.remove('qb-qv-open');
    if (qvLastFocus && qvLastFocus.focus) qvLastFocus.focus();
    qvLastFocus = null;
  }

  root.querySelector('.qb-grid').addEventListener('click', function (e) {
    var view = e.target.closest('[data-role="view"]');
    if (!view) return;
    e.preventDefault();
    openQv(view.closest('.qb-card'));
  });

  if (qvEl) {
    qvEl.addEventListener('click', function (e) {
      if (e.target.closest('[data-role="qv-close"]')) closeQv();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeQv();
    });
    document.getElementById('qb-qv-pick').addEventListener('click', function () {
      if (!qvCard) return;
      var btn = qvCard.querySelector('[data-role="pick"]');
      if (btn && !btn.disabled) btn.click();
    });
  }

  /* ---------- tracker CTA ---------- */
  ctaEl.addEventListener('click', function () {
    var action = ctaEl.dataset.action;
    if (action === 'checkout') {
      window.location.href = '/cart';
    } else if (action === 'bikes') {
      var target = document.getElementById('qb-featured-bike');
      if (target.hidden) target = root.querySelector('.qb-bikes');
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      root.querySelector('.qb-grid').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  fetchCart();
})();
